import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 md:mb-7">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-accent-500 md:h-7"></span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-secondary-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
        >
          {moreLabel || "查看全部"}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}